import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

import { registerControllers } from 'stimulus-vite-helpers'

const controllers = import.meta.glob('./**/*_controller.*', { eager: true })
registerControllers(application, controllers)

import { Tabs, Modal } from "tailwindcss-stimulus-components"
application.register('tabs', Tabs)
application.register('modal', Modal)

import PasswordVisibility from '@stimulus-components/password-visibility'
application.register('password-visibility', PasswordVisibility)

import Clipboard from '@stimulus-components/clipboard'
application.register('clipboard', Clipboard)